import { Component, OnInit } from '@angular/core';
import { Warehouse } from '../warehouse';
import { WarehouseService } from '../warehouse.service';

import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StateService } from '../../state/state.service';
import { State } from '../../state/state';
import { City } from '../../city/city';
import { CityService } from '../../city/city.service';
import { User } from '../../user/user';
import { UserService } from '../../user/user.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilityService } from  '../../utility.service';
import { Router} from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-create-warehouse',
  templateUrl: './create-warehouse.component.html',
  styleUrls: ['./create-warehouse.component.css']
})
export class CreateWarehouseComponent implements OnInit {

  warehouse = new Warehouse();
  warehousedata : any = {}
  submitted = false;
  cities: City[];
  states: State[];
  users: User[];
  totalrecord:number;
  message: string;
  warehouseForm: FormGroup;
  public isupdate = false;
public FormName = "Add Warehouse";
mobnumPattern = "^((\\+91-?)|0)?[0-9]{10}$"; 
gstPattern = "^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$";

  constructor(
    private warehouseService: WarehouseService,
    private cityService: CityService,
    private stateService: StateService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private util:UtilityService, 
    public toastr: ToastrManager,
    private location: Location,
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.warehouse.active = 1;
    this.getStates();
    this.getcities();
    this.getUsers();
    if(this.route.snapshot.paramMap.get('warehouseid') != null)
			{
        const warehouseId = +this.route.snapshot.paramMap.get('warehouseid');
				 if(warehouseId > 0)
				 {
					 this.getWarehouse(warehouseId);
				 }
				 this.isupdate = true;
				 this.FormName = "Update Warehouse";
				 
			}
    this.warehouseForm = this.formBuilder.group({			
      warehousename: [this.warehouse.warehousename,[Validators.required, Validators.required]],
      address: [this.warehouse.address,[Validators.required, Validators.required]],
      stateid: [this.warehouse.stateid,[Validators.required, Validators.required]],
      cityid: [this.warehouse.cityid,[Validators.required, Validators.required]],
      pincode: [this.warehouse.pincode,[Validators.required, Validators.required]],
      warehousemanagerid: [this.warehouse.warehousemanager,[Validators.required, Validators.required]],
      mangerphoneno: [this.warehouse.mangerphoneno,[Validators.required, Validators.required]],
      gstin: [this.warehouse.gstin,[Validators.required, Validators.required, Validators.pattern(this.gstPattern)]],
      active: [this.warehouse.active,[Validators.required, Validators.required]]
    });	
  }
// convenience getter for easy access to form fields
get f() {
  return this.warehouseForm.controls
  }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.warehouseForm.invalid) {
        return this.util.showError("Please enter required fields.");		
    }
  else{
    if(this.isupdate){
      this.updateWarehouse();
    }
    else{
      this.addWarehouse();
    }
  }
}

getUsers() {
  return this.userService.getUsers()
             .subscribe(
              users => {
                console.log(users);
                this.users = users;
                this.totalrecord = this.users.length;
               }
              );
}

  public addWarehouse() {
    this.save();
  }
  public updateWarehouse() {
    this.update();
  }
  
private save(): void {
  this.warehousedata = this.warehouse;
   this.warehousedata.createdby = this.auth.currentUserValue.userid
  this.warehouseService.addWarehouse(this.warehousedata).subscribe(() => 
  { 
  this.util.showSuccess("Warehouse added successfully.");
  this.router.navigate(['/warehouse-list']);
  });
  // this.goBack();  //for Redirecting to the list view     
}

update(): void {
  //this.submitted = true;
  this.submitted = true;
  this.warehousedata = this.warehouse;
  this.warehousedata.modifiedby = this.auth.currentUserValue.userid;
  this.warehousedata.modifiedon = Date.now();
  this.warehouseService.updateWarehouse(this.warehousedata)
      .subscribe(() => 
	  { 
	  this.util.showSuccess("Warehouse update successfully.");
      this.router.navigate(['/warehouse-list']);
	  });
}



  getStates() {
    return this.stateService.getStates()
               .subscribe(
                 states => {
                  console.log(states);
                  this.states = states.filter(item => item.active == 1);
                 }
                );
 }
 
 getcities() {
  return this.cityService.getCities()
             .subscribe(
              cities => {
                console.log(cities);
                this.cities = cities.filter(item => item.active == 1);
               }
              );
}

 getWarehouse(warehouseid) {
  return this.warehouseService.GetWarehouses(warehouseid)
             .subscribe(
              warehouse => {
                console.log(warehouse);
                this.warehouse = warehouse
                //this.getCityByState(this.vendor.stateid);
               }
              );
}
public onStateChangeObj(filterstateID){
	//	this.FiltercityArray =  this.cityArray.filter(c => c.stateid === filterstateID);
		this.getCityByState(filterstateID);
  }
  
getCityByState(stateid) {
  return this.cityService.getCityByState(stateid)
             .subscribe(
               cities => {
                console.log(cities);                  
                this.cities = cities
               }
              );
  }
}
